module.exports = __webpack_public_path__ + "img/pic_162913_1.eb71d56b.jpg";